import SearchBar from 'components/common/dataTable/searchBar'
import DataTableImportButton from 'components/common/dataTable/dataTableImportButton'
import { ImportColumn } from 'components/common/importModal'
import { FreshMandatoryBarcodeTable } from 'components/freshMandatoryBarcode'
import { usePageAccess } from 'hooks'
import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { downloadImportSample, getImportTemplate } from 'utils/api/importApi'
import { importFreshMandatoryBarcodes } from 'utils/api/freshMandatoryBarcodeApi'

const IMPORT_MODULE = 'freshMandatoryBarcode'

const FreshMandatoryBarcodeList = () => {
  const { isEditor } = usePageAccess()
  const [importColumns, setImportColumns] = useState<ImportColumn[]>([])

  useEffect(() => {
    getImportTemplate(IMPORT_MODULE)
      .then(({ data }) => setImportColumns(data?.columns ?? []))
      .catch(() => setImportColumns([]))
  }, [])

  const handleDownloadSample = async () => {
    const response = await downloadImportSample(IMPORT_MODULE)
    const url = URL.createObjectURL(
      new Blob([response.data], { type: 'text/csv' }),
    )
    const link = document.createElement('a')
    link.href = url
    link.download = 'fresh_mandatory_barcode_sample.csv'
    link.click()
    URL.revokeObjectURL(url)
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Fresh Mandatory Barcodes</title>
      </Helmet>

      {isEditor && (
        <div className="mb-5 flex items-center gap-3">
          <DataTableImportButton
            label="Import Mandatory Barcodes"
            uploadApiFunction={importFreshMandatoryBarcodes}
            className="border border-gray-300"
            importColumns={importColumns}
            importModuleName="Fresh mandatory barcodes"
            onDownloadSample={handleDownloadSample}
          />
        </div>
      )}

      <div className="mb-2 flex flex-wrap items-center justify-between md:mb-0 md:flex-nowrap">
        <div>
          <h3 className="title">Mandatory Barcodes</h3>
          <p className="mt-1 text-sm text-gray-500">
            Set to 1000 every night, and never changed from the Fresh mobile
            app. One row per barcode per store. Uploading a file only affects
            the barcodes listed in it.
          </p>
        </div>
        <SearchBar placeholder="Search by barcode or store code" />
      </div>

      <FreshMandatoryBarcodeTable />
    </>
  )
}

export default FreshMandatoryBarcodeList
